export const classNames = (...values) => values.filter(Boolean).join(" ");

export default classNames;
